import React from 'react';
import { Globe } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

const LanguagesSection = ({ languages, cvService }) => {
  if (!languages || languages.length === 0) return null;

  const getLevelVariant = (level) => {
    const levelLower = level.toLowerCase();
    if (levelLower.includes('natif') || levelLower.includes('native')) {
      return 'default';
    }
    if (levelLower.includes('courant') || levelLower.includes('fluent')) {
      return 'secondary';
    }
    if (levelLower.includes('intermédiaire') || levelLower.includes('intermediate')) {
      return 'outline';
    }
    if (levelLower.includes('débutant') || levelLower.includes('beginner')) {
      return 'outline';
    }
    return 'secondary';
  };

  return (
    <div className="mb-2">
      {/* Contenu principal */}
      <div className=" backdrop-blur-md rounded-xl p-4 border border-hair shadow-xl">
        <div className="flex items-center mb-8">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-space-600 to-space-700 flex items-center justify-center mr-4 shadow-lg">
            <Globe className="text-white" size={20} />
          </div>
          <h2 className="text-2xl font-bold text-ink tracking-tight">
            {cvService.locale === 'fr' ? 'Langues' : 'Languages'}
          </h2>
        </div>
        
        <Card className="bg-gradient-to-br from-space-800 to-space-900/50 backdrop-blur-sm border-hair shadow-lg rounded-xl overflow-hidden">
          <CardHeader className="bg-gradient-to-r from-space-800 to-space-900 border-b border-hair pb-4">
            <CardTitle className="text-xl font-bold text-ink tracking-tight flex items-center">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-space-600 to-space-700 flex items-center justify-center mr-3 shadow-lg">
                <Globe size={16} className="text-white" />
              </div>
              {cvService.locale === 'fr' ? 'Compétences linguistiques' : 'Language Skills'}
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6 bg-gradient-to-br from-space-800 to-space-900/30">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {languages.map((language, index) => {
                const lang = cvService.getTranslatedValue(language.lang);
                const levelVariant = getLevelVariant(language.level);

                return (
                  <div
                    key={index}
                    className="flex items-center justify-between p-4 rounded-lg bg-space-800/70 backdrop-blur-sm border border-hair hover:bg-space-700 hover:border-hair-bright hover:shadow-md transition-all duration-300"
                  >
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 rounded-full bg-space-700 flex items-center justify-center shadow-sm">
                        <Globe size={18} className="text-ink-muted" />
                      </div>
                      <span className="font-semibold text-ink">{lang}</span>
                    </div>
                    
                    <Badge 
                      variant={levelVariant}
                      className="bg-gradient-to-r from-space-700 to-space-900 text-ink-muted border-hair px-3 py-1 font-medium"
                    >
                      {language.level}
                    </Badge>
                  </div>
                );
              })}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LanguagesSection;
